import script from "./mappingData.vue?vue&type=script&setup=true&lang=js"
export * from "./mappingData.vue?vue&type=script&setup=true&lang=js"

import "./mappingData.vue?vue&type=style&index=0&id=50acf916&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50acf916"]])

export default __exports__